import React from 'react'
import { shallow } from 'enzyme'

import loan from './testData/loan'

import ModalBody from '../ModalBody'
import Probabilities from '../Probabilities'
import KeyAttributes from '../KeyAttributes'
import SmartRateHistory from '../SmartRateHistory'
import Loader from '../../common/Loader'
import Error from '../../common/Error'

describe('<ModalBody />', () => {
  let wrapper, props
  beforeEach(() => {
    props = {
      error: null,
      loading: false,
      loan: JSON.parse(JSON.stringify(loan))
    }
    wrapper = shallow(<ModalBody {...props} />)
  })
  it('should render a <Loader /> if its loading prop is true', () => {
    wrapper.setProps({ loading: true })
    expect(wrapper.find(Loader)).toHaveLength(1)
  })
  it('should render an <Error /> if its error prop is truthy', () => {
    wrapper.setProps({ error: true })
    expect(wrapper.find(Error)).toHaveLength(1)
  })
  it('should render a <Loader /> if its loan prop is null', () => {
    wrapper.setProps({ loan: null })
    expect(wrapper.find(Loader)).toHaveLength(1)
  })
  it('should render a <Probabilities />', () => {
    expect(wrapper.find(Probabilities)).toHaveLength(1)
  })
  it('should render a <KeyAttributes />', () => {
    expect(wrapper.find(KeyAttributes)).toHaveLength(1)
  })
  it('should render a <SmartRateHistory />', () => {
    expect(wrapper.find(SmartRateHistory)).toHaveLength(1)
  })
})
